import { observer } from 'mobx-react';
import React from 'react';
import PropTypes from 'prop-types';
import VoucherTpl from '../components/vertical/voucherVertical';
import './style.less'
import { action, toJS } from 'mobx';
import { injectViewModel } from 'mutants-appfx';
import {stores,i18n} from 'mutants-microfx';
import { PosInitData, TStore } from 'tplus-poslogin';
import _throttle from 'lodash/throttle'
import UiCommon from '../util/uiCommon.js'
import common from '../util/common.js'
import {Ticon,ModalWraper } from 'tplus-components-touch'
const t = i18n.getFixedT(null, 'newretail');
@injectViewModel('Voucher')
@observer
class RetailOrderView extends React.Component {

    openWeightParams//电子秤数据
    amountThreshold//应收金额 监测的屏幕宽度阈值

    constructor(props) {
        super(props)
    }

    static contextTypes = {
        router: PropTypes.object,
        onEvent: PropTypes.func,
        onAction: PropTypes.func,
        stores: PropTypes.object,
        infoRender: PropTypes.func,
        headHook: PropTypes.object,
        viewModel: PropTypes.object
    }
    static propTypes = {
        match: PropTypes.object
    }

    getChildContext() {
        const storeInfo = TStore.restore();
        return {
            storeInfo
        }
    }

    static childContextTypes = {
        storeInfo: PropTypes.object,
    }


    resize = () => {
        const width = document.body.clientWidth;
        this.setState({
            underAmountThreshold: width <= this.amountThreshold
        })
    }

    componentWillUnmount(){
        rx$.headRenderSubject.closed || rx$.headRenderSubject.next();
    }

    componentDidMount(){
       const voucherStore = stores.voucherStore;
       const dataModal = voucherStore.getData();
       if(!dataModal)return ;
       const { controllerEvent } = this.props;
       controllerEvent('loadWithoutVoucherBody',dataModal);
    }

    /* 结算成功回调 */
    @action onSettleSuccess({ openCashBox }) {
        const { controllerEvent } = this.props;
        // 先打印然后重新开单
        controllerEvent('printRetail', { openCashBox }).then(() => {
            controllerEvent('clearVoucherData', { keep: true });
        });

    }
    /* 取消结算 */
    onCancelSettle() {
        const { controllerEvent } = this.props;
        controllerEvent('cancelPromotion', true);
    }

    /* 特定报错 重新开单 */
    @action clearVoucherData = () => {
        const { controllerEvent } = this.props;
        controllerEvent('clearVoucherData');
    }

    /* 结算校验 */
    onValidate = () => {
        const { controllerEvent } = this.props;
        UiCommon.mask({});
        // 需要异步校验
        return new Promise((resolve, reject) => {
            controllerEvent('onValidate').then(() => {
                UiCommon.deleteMask({ async: true });
                resolve(this.props.viewModel.settlementVisiable);
            }).catch((err) => {
                console.warn(err)
                UiCommon.deleteMask({ async: true });
            })
        });
    }

    onCollapse = (collapsed) => {
        this.setState({ collapsed });
    }

    clearModel(){
        const {controllerEvent} = this.props;
        ModalWraper.confirm({
            title: t('不想要了'),
            content: t('确定要取消当前交易吗？如需帮助请联系工作人员。'),
            onOk: () => {
                controllerEvent('clearVoucherData')
            }
        })
    }

    render() {
        //渲染不想买了
        let voucherVM = this.props.viewModel;
        if (!!voucherVM.totalQuantity) {
            rx$ && rx$.headRenderSubject.next(
                <span
                    className='voucher-head-giveup'
                    style={{ display: 'inline-block', marginRight: '20px' }}
                    onClick={() => {
                        this.clearModel();
                    }}
                >
                    <Ticon type='buyaole' className='buyaole'></Ticon>不想要了
                </span>
            )
        } else {
            rx$ && rx$.headRenderSubject.next();
        }
        return (
            <div className="voucher-wraper-layer" ref={(el) => { this.barcodeEl = el }}>
                <VoucherTpl />
            </div>

        );
    }
}

export default RetailOrderView;
